import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { CustomDomainStatus } from '@/api/customDomains/customDomainsApi.types';
import { resolveCustomDomainStatusTone } from './customDomainPresentation';

interface CustomDomainStatusBadgeProps {
  status: CustomDomainStatus;
}

export function CustomDomainStatusBadge({ status }: CustomDomainStatusBadgeProps) {
  const { t } = useTranslation('customDomains');
  return (
    <Badge tone={resolveCustomDomainStatusTone(status)} size="md">
      {t('status.' + status)}
    </Badge>
  );
}
